export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-950 to-background-800 rounded-2xl overflow-hidden border border-background-700/30">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-300 text-xs font-medium tracking-wide mb-4">
                随时随地
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
                移动观影
              </h2>
              <p className="text-white/65 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                窝窝影院完美适配手机与平板浏览器，无需下载任何 APP。
                打开浏览器即可畅享与桌面端一致的<strong className="text-white/85">免费高清</strong>观影体验。
                支持 iOS Safari、Android Chrome 等主流移动浏览器，随时随地追剧观影。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 text-white/80 text-sm">
                  <i className="ri-apple-line text-lg"></i>
                  <span>iOS 支持</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 text-white/80 text-sm">
                  <i className="ri-android-line text-lg"></i>
                  <span>Android 支持</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 text-white/80 text-sm">
                  <i className="ri-tablet-line text-lg"></i>
                  <span>平板适配</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-full max-w-[280px] lg:max-w-[320px] p-6 md:p-8">
              <div className="relative">
                <div className="absolute -inset-3 bg-gradient-to-r from-primary-500/30 via-accent-500/20 to-primary-500/30 rounded-3xl blur-lg"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20elegant%20movie%20streaming%20interface%20with%20dark%20theme%2C%20film%20poster%20thumbnails%2C%20clean%20UI%20design%2C%20warm%20accent%20colors%2C%20cinematic%20app%20screen%2C%20minimalist%20layout%2C%20floating%20device%20presentation%2C%20soft%20studio%20lighting%2C%20product%20photography%20style&width=500&height=900&seq=app-mobile-screen&orientation=portrait"
                  alt="窝窝影院移动端观影体验"
                  className="relative w-full h-auto rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}